<template>
    <div @click="closeOverlay" class="cielo-overlay">
        <div :style="{ top: topSpaceFormatted }" @click.stop.self class="cielo-overlay-card">
            <div class="cielo-overlay-card__container">
                <header>
                    <span tabindex="0">{{ title }}</span>

                    <button @click="closeOverlay" class="close-button" :aria-label="$ml.get('ariaCTACloseOverlay')">
                        <img src="@/assets/img/icons/close-blue.svg" alt="" tabindex="-1" />
                    </button>
                </header>
                <ul 
                    class="cielo-overlay-card__list"
                    @scroll.passive="handleOnScroll"
                    :aria-label="$ml.get('ariaSelectList') + title"
                    :tabindex="isOptionsOpen ? 0 : -1"
                >
                    <slot />
                </ul>
                <div class="overlay__footer" />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                required: true
            },
            isOptionsOpen: {
                type: Boolean
            }
        },

        data() {
            return {
                topSpace: 100
            };
        },

        computed: {
            topSpaceFormatted: (self) => self.topSpace + 'px'
        },

        methods: {
            closeOverlay() {
                this.$emit('closeOverlay');
            },

            handleOnScroll() {
                // TODO: Implementar animação

                // let speed = 2;
                // let scrollTop = event.target.scrollTop;
                // let topSpace = 325 - (scrollTop * speed);

                // if (topSpace <= 0) {
                //     this.topSpace = 0;
                //     return;
                // }

                // this.topSpace = topSpace;
            }
        }
    };
</script>

<style lang="scss" scoped>
    .cielo-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: RGBA(32,31,32,0.6);
        z-index: 2000;
    }

    .cielo-overlay-card {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        background: #FFF;
        border-radius: 12px 12px 0px 0px;

        &__container {
          height: 100%;
          padding: 0 16px;
          display: flex;
          flex-direction: column;
        }

        header {
            margin-top: 16px;
            margin-bottom: 20px;
            position: relative;

            span {
				display: block;
				max-width: 280px;
                font-size: 20px;
                font-weight: 700;
                line-height: 28px;
            }
        }

        &__list {
            list-style-type: none;
            /* scrollbar do componente de bottom sheet */
            overflow-y: auto;
            touch-action: pan-y;
            user-select: none;
            margin-right: 8px;
            padding-left: 0;
            padding-right: 12px;
            margin-bottom: 20px;

            /* firefox css fix */
            scrollbar-color: #0774E7 #EAEEF3;
            scrollbar-width: thin;
            &::-webkit-scrollbar {
              width: 4px !important;
            }
            &::-webkit-scrollbar-track {
              background: #EAEEF3 !important;
              border-radius: 8px !important;
            }
            &::-webkit-scrollbar-thumb {
              background-color: #0774E7 !important;
              border-radius: 8px !important;
            }
        }
    }

    .close-button {
        position: absolute;
        top: 0;
        right: 0;
        background-color: transparent;
        border: none;
        padding: 0;
    }
</style>
